import { _isOnScreen, _once } from '../../utils';

/* eslint-disable */
function isLivechatAllowed() {
  return !!document.getElementById('allow-livechat') && window.allowLivechat;
}

function connectLivechat() {
  window.helpcrunchSettings = {
    organization: 'uvoteam',
    appId: '2c3cd2a1-db5a-4beb-a023-90818e645e85',
  };
  // prettier-ignore
  // @ts-ignore
  (function(w,d){var hS=w.helpcrunchSettings;if(!hS||!hS.organization){return;}var widgetSrc='https://embed.helpcrunch.com/sdk.js';w.HelpCrunch=function(){w.HelpCrunch.q.push(arguments)};w.HelpCrunch.q=[];function r(){if (d.querySelector('script[src="' + widgetSrc + '"')) { return; }var s=d.createElement('script');s.async=1;s.type='text/javascript';s.src=widgetSrc;(d.body||d.head).appendChild(s);}if(d.readyState === 'complete'||hS.loadImmediately){r();} else if(w.attachEvent){w.attachEvent('onload',r)}else{w.addEventListener('load',r,false)}})(window, document)
}

if (isLivechatAllowed()) {
  document.addEventListener('b:auth', e => {
    // @ts-ignore
    if (!e.detail.user_role) {
      _isOnScreen(
        '.header__beacon',
        () => {},
        {},
        _once(() => {
          connectLivechat();
        }),
      );
    }
  });
}
